import { proxy } from 'valtio';

import { PathPresentation } from '@canvas/model/elements/path';
import { PathStroke, PathStrokeStyle } from '@canvas/model/elements/path';
import { PathCap } from '@canvas/model/elements/path';

export const defaultPathPresentation = PathPresentation.DYNAMIC;
export const defaultStroke = PathStroke.SMALL;
export const defaultStrokeStyle = PathStrokeStyle.SOLID;
export const defaultStartCap = PathCap.NONE;
export const defaultEndCap = PathCap.ARROW;

export const currentPathPresentation = proxy({
  presentation: defaultPathPresentation,
  stroke: defaultStroke,
  strokeStyle: defaultStrokeStyle,
  startCap: defaultStartCap,
  endCap: defaultEndCap,
});
